/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2025 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { COMPANY_FRAGMENT, CUSTOMER_FRAGMENT } from '@/company-switcher/api/fragments';

export const GET_CUSTOMER_COMPANY_CONTEXT = /* GraphQL */ `
  query GET_CUSTOMER_COMPANIES($pageSize: Int) {
    customer {
      ...CUSTOMER_FRAGMENT
    }
    company {
      ...COMPANY_FRAGMENT
    }
    customerGroup {
      uid
    }
  }

  ${CUSTOMER_FRAGMENT}
  ${COMPANY_FRAGMENT}
`;
